import { SemanticUiColorOptions } from 'Common/Constants/SemanticUiColors';
import { get } from 'lodash';
import { CategoryEnum } from 'Pages/serveditemsetup/helpers/constants';

export const getColor = (item, nutritionCodes, itemCategories) => {
  if (SemanticUiColorOptions.some(o => o.value === item.Color)) {
    return item.Color;
  }

  // If the item is planned then use category color over nutrition code color
  if (item.ItemCategoryId === CategoryEnum.Planned) {
    return get(itemCategories.find(c => c.Id === item.ItemCategoryId), 'Color');
  }

  const nutritionCodeColor = get(
    nutritionCodes.find(c => c.Code === item.NutritionCode),
    'Color'
  );
  if (SemanticUiColorOptions.some(o => o.value === nutritionCodeColor)) {
    return nutritionCodeColor;
  }

  const categoryColor = get(
    itemCategories.find(c => c.Id === item.ItemCategoryId),
    'Color'
  );

  if (SemanticUiColorOptions.some(o => o.value === categoryColor)) {
    return categoryColor;
  }

  return categoryColor;
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/helpers/servedItemButtonColor.js